// extracted by mini-css-extract-plugin
export default {"root":"LearningPaths_root__s1YRD"};